import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Box, Typography, Button, FormControl, useTheme } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Calendar } from "@phosphor-icons/react";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { Gear } from "@phosphor-icons/react";
const PICKER_FIELD_PROPS = {
    textField: {
        inputProps: { readOnly: true },
        onKeyDown: (e) => e.preventDefault(),
        sx: {
            width: { xs: 171, sm: 209, md: "auto" },
            "& .MuiPickersInputBase-sectionsContainer": { padding: { xs: "13.5px 0px", sm: "13.5px 0px", md: "16.5px 0px" } },
            "& .MuiPickersInputBase-input, & .MuiInputBase-input": { cursor: "pointer", caretColor: "transparent" },
        },
    },
};
export const DashboardKpiTopHeader = ({ filters, onFiltersChange, onSetWeeklyTargets, }) => {
    const theme = useTheme();
    const { t: translate } = useTranslation();
    const startValue = filters.startDate ? dayjs(filters.startDate) : null;
    const endValue = filters.endDate ? dayjs(filters.endDate) : null;
    const handleStartChange = (date) => {
        if (!date || !date.isValid())
            return;
        const formatted = date.format("YYYY-MM-DD");
        if (endValue && date.isAfter(endValue, "day")) {
            onFiltersChange({ startDate: formatted, endDate: formatted });
        }
        else {
            onFiltersChange(Object.assign(Object.assign({}, filters), { startDate: formatted }));
        }
    };
    const handleEndChange = (date) => {
        if (!date || !date.isValid())
            return;
        const formatted = date.format("YYYY-MM-DD");
        if (startValue && date.isBefore(startValue, "day")) {
            onFiltersChange({ startDate: formatted, endDate: formatted });
        }
        else {
            onFiltersChange(Object.assign(Object.assign({}, filters), { endDate: formatted }));
        }
    };
    return (_jsxs(Box, { sx: {
            display: "flex",
            justifyContent: "space-between",
            flexDirection: { xs: "column", md: "row" },
            alignItems: { xs: "stretch", md: "center" },
            gap: 2,
            py: 2,
            flexWrap: { xs: "wrap", lg: "nowrap" },
        }, children: [_jsx(Typography, { variant: "h1", sx: { color: theme.palette.text.primary, whiteSpace: "nowrap", flexShrink: 0 }, children: translate("DashboardKPI") }), _jsxs(Box, { sx: {
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    flexWrap: { xs: "wrap", md: "nowrap", lg: "nowrap" },
                }, children: [_jsxs(Typography, { sx: { whiteSpace: "nowrap" }, children: [translate("selectRange"), ":"] }), _jsx(Box, { sx: { display: "flex", gap: 1 }, children: _jsxs(LocalizationProvider, { dateAdapter: AdapterDayjs, children: [_jsx(FormControl, { variant: "outlined", children: _jsx(DatePicker, { label: translate("Start Date"), value: startValue, onChange: handleStartChange, maxDate: endValue !== null && endValue !== void 0 ? endValue : undefined, format: "DD-MM-YYYY", slots: { openPickerIcon: Calendar }, slotProps: PICKER_FIELD_PROPS }) }), _jsx(FormControl, { variant: "outlined", children: _jsx(DatePicker, { label: translate("Date"), value: endValue, onChange: handleEndChange, minDate: startValue !== null && startValue !== void 0 ? startValue : undefined, format: "DD-MM-YYYY", slots: { openPickerIcon: Calendar }, slotProps: PICKER_FIELD_PROPS }) })] }) }), onSetWeeklyTargets && (_jsx(Button, { variant: "contained", startIcon: _jsx(Gear, { size: 20 }), onClick: onSetWeeklyTargets, sx: { minWidth: 250 }, children: translate("Set Weekly Targets") }))] })] }));
};
